import React from 'react'
import { Link } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'

// components
import FormCard from 'components/atoms/FormCard'
import FormButton from 'components/atoms/FormButton'
import ErrorMessage from 'components/shared/ErrorMessage'
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'
import FormSelectWithValidation from 'components/shared/FormSelectWithValidation'

import { relationshipToCampersOptions } from './selectionOptions'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import FormControlWithErrorHelper from '../../../shared/FormControlWithErrorHelper'

const PickupPersonForm = props => {
  const {
    form,
    onChangeFormField,
    mutationLoading,
    handleSubmit,
    formErrors,
    buttonText,
    redirect,
    showFormFields = true
  } = props

  return (
    <FormCard>
      <ErrorMessage />
      {showFormFields && (
        <form>
          <FormTextFieldWithValidation
            label='First Name'
            field='firstName'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          />

          <FormTextFieldWithValidation
            label='Last Name'
            field='lastName'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          />

          <FormSelectWithValidation
            label='Relationship To Child/Children'
            field='relationshipToCampers'
            form={form}
            options={relationshipToCampersOptions.map(option => [
              option.toLowerCase(),
              option
            ])}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          />

          <FormControlWithErrorHelper
            component='fieldset'
            required
            errorsObject={formErrors}
            errorField='legalGuardian'
          >
            <FormLabel component='legend' htmlFor='legalGuardian'>
              Is this adult a Legal Guardian?
            </FormLabel>
            <RadioGroup
              id='legalGuardian'
              value={form.legalGuardian}
              onChange={onChangeFormField('legalGuardian')}
              aria-label='legalGuardian'
              name='legalGuardian'
            >
              <FormControlLabel value='true' control={<Radio />} label='Yes' />
              <FormControlLabel value='false' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControlWithErrorHelper>

          <FormTextFieldWithValidation
            label='Daytime Phone (with area code)'
            field='primaryPhone'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
            required
          >
            <FormHelperText>
              Fastest way to reach Emergency Contact during business hours.
            </FormHelperText>
            <FormHelperText>International: +## ### ### ###</FormHelperText>
          </FormTextFieldWithValidation>

          <FormTextFieldWithValidation
            label='Alternate Phone (with area code)'
            field='alternatePhone'
            form={form}
            onChange={onChangeFormField}
            errors={formErrors}
          >
            <FormHelperText>International: +## ### ### ###</FormHelperText>
          </FormTextFieldWithValidation>

          <Box py={2} align='center'>
            <FormButton variant='outlined' component={Link} to={redirect}>
              Cancel
            </FormButton>
            <FormButton
              variant='contained'
              color='secondary'
              disabled={mutationLoading}
              onClick={handleSubmit}
            >
              {buttonText}
            </FormButton>
          </Box>
        </form>
      )}
    </FormCard>
  )
}

export default PickupPersonForm
